/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Ladda = require('ladda');

var SideNavSectionView = require('common/views/SideNavSectionView');
var switchToPrint = require('common/util/switchToPrint');

var DebtSettlementServicesAnnualReportGeneralDetailsSectionView = require('./DebtSettlementServicesAnnualReportGeneralDetailsSectionView');
var DebtSettlementServicesAnnualReportFinancialStatementsSectionView = require('./DebtSettlementServicesAnnualReportFinancialStatementsSectionView');
var DebtSettlementServicesAnnualReportVolumeAndRetentionSectionView = require('./DebtSettlementServicesAnnualReportVolumeAndRetentionSectionView');
var DebtSettlementServicesAnnualReportLicenseeActionsSectionView = require('./DebtSettlementServicesAnnualReportLicenseeActionsSectionView');
var DebtSettlementServicesAnnualReportChangesInOwnershipSectionView = require('./DebtSettlementServicesAnnualReportChangesInOwnershipSectionView');
var DebtSettlementServicesAnnualReportAffirmationSectionView = require('./DebtSettlementServicesAnnualReportAffirmationSectionView');
var SubmitDebtSettlementServicesAnnualReport = require('../../services/SubmitDebtSettlementServicesAnnualReport');

var tmplDebtSettlementServicesAnnualReportView = require('./DebtSettlementServicesAnnualReportView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDebtSettlementServicesAnnualReportView,

  className: 'debt-settlement-services-annual-report-view m-b-md',

  behaviors: {
    ReadOnlyFormBehavior: {}
  },

  ui: {
    debtSettlementServicesAnnualReportContainer: '.debt-settlement-services-annual-report-container'
  },

  regions: {
    debtSettlementServicesAnnualReportContainer: '@ui.debtSettlementServicesAnnualReportContainer'
  },

  onBeforeShow: function() {
    var mode = this.options.mode;
    var isForPrinting = mode === 'print';
    var isExpandInternal = mode === 'int-expand';

    this.form = new SideNavSectionView({
      collection: new Backbone.Collection([
        {
          id: 'debtSettlementServicesAnnualReportGeneralDetails',
          title: 'General Details',
          showRequiredFieldDisclaimer: !this.options.isReadOnly,
          view: new DebtSettlementServicesAnnualReportGeneralDetailsSectionView({
            isReadOnly: this.options.isReadOnly,
            model: this.model
          })
        },
        {
          id: 'debtSettlementServicesAnnualReportFinancialStatements',
          title: 'Financial Statements',
          view: new DebtSettlementServicesAnnualReportFinancialStatementsSectionView({
            isReadOnly: this.options.isReadOnly,
            model: this.model
          })
        },
        {
          id: 'debtSettlementServicesAnnualReportVolumeAndRetention',
          title: 'Volume and Retention',
          showRequiredFieldDisclaimer: !this.options.isReadOnly,
          view: new DebtSettlementServicesAnnualReportVolumeAndRetentionSectionView({
            isReadOnly: this.options.isReadOnly,
            model: this.model
          })
        },
        {
          id: 'debtSettlementServicesAnnualReportLicenseeActions',
          title: 'Actions Against the Licensee',
          showRequiredFieldDisclaimer: !this.options.isReadOnly,
          view: new DebtSettlementServicesAnnualReportLicenseeActionsSectionView({
            isReadOnly: this.options.isReadOnly,
            model: this.model
          })
        },
        {
          id: 'debtSettlementServicesAnnualReportChangesInOwnership',
          title: 'Changes in Ownership',
          showRequiredFieldDisclaimer: !this.options.isReadOnly,
          view: new DebtSettlementServicesAnnualReportChangesInOwnershipSectionView({
            isReadOnly: this.options.isReadOnly,
            model: this.model
          })
        },
        {
          id: 'debtSettlementServicesAnnualReportAffirmation',
          title: 'Affirmation',
          showRequiredFieldDisclaimer: !this.options.isReadOnly,
          view: new DebtSettlementServicesAnnualReportAffirmationSectionView({
            isReadOnly: this.options.isReadOnly,
            mode: this.options.mode,
            model: this.model
          })
        }
      ]),
      expanded: isForPrinting || isExpandInternal,
      useNavigationButtons: !this.options.isReadOnly,
      contentWidth: 'medium',
      buttons: [
        {
          buttonText: 'Save',
          buttonClass: 'btn-default ladda-button',
          buttonIconClass: 'fa-save',
          labelClass: 'ladda-label',
          buttonAttrs: {
            'data-style': 'expand-right'
          },
          onClick: this.onClickSave.bind(this)
        }
      ]
    });

    if (
      this.options.isReadOnly &&
      !(this.options.mode === 'print' || this.options.mode === 'int' || this.options.mode === 'int-expand')
    ) {
      this.form.collection.remove(this.form.collection.get('debtSettlementServicesAnnualReportAffirmation'));
    }

    this.showChildView('debtSettlementServicesAnnualReportContainer', this.form);
  },

  onClickSave: function(e) {
    e.preventDefault();
    var self = this;
    self.form.validateAll({ type: 'save' }).done(function() {
      var l = Ladda.create(e.currentTarget);
      l.start();
      var rawFormData = self.form.getFormData();
      var formData = {
        applicationId: self.model.get('applicationId'),
        annualReportId: self.model.get('annualReportId'),
        generalDetails: rawFormData.debtSettlementServicesAnnualReportGeneralDetails,
        volumeAndRetention: rawFormData.debtSettlementServicesAnnualReportVolumeAndRetention,
        licenseeActions: rawFormData.debtSettlementServicesAnnualReportLicenseeActions,
        changesInOwnership: rawFormData.debtSettlementServicesAnnualReportChangesInOwnership,
        activityInOtherStates: rawFormData.debtSettlementServicesAnnualReportActivityInOtherStates,
        affirmation: rawFormData.debtSettlementServicesAnnualReportAffirmation
      };
      SubmitDebtSettlementServicesAnnualReport(formData)
        .done(function() {
          l.stop();
        })
        .fail(function() {
          l.stop();
        });
    });
  },

  onAttach: function() {
    if (this.options.mode === 'print') {
      switchToPrint(this.$el, '.input-view');
    }
  }
});
